// 默认值为true(开发模式)
// 一般不需要修改. 如果想在开发模式调试测试环境的话, 修改成 false 即可
let tms_devlope = false;
let useSSL = !tms_devlope /////!tms_devlope  //是否使用安全方式访问（https协议）
let defaultLang = 'zh_cn' // zh_ch en ru ko
export const isShowProductLineModel = true //应用渠道商处，是否显示证书相关操作模块

if (process.env.NODE_ENV !== 'development') {
  // 监听是否使用 build命令, 如果是则默认为测试环境
  // run with build
  // test server
  // tms_devlope = false
  // useSSL = true
}

/**
 * ----菜单配置方法----
 * 创建大类时-例如应用管理
 * url--->/
 * uri--->home
 * 创建二级菜单时-例如PSP应用管理
 * url--->/pspList
 * uri--->totalpages
 * 创建二级菜单时可顺便创建三级菜单-列表
 * url--->/
 * uri--->apps/pspList
 * 创建三级菜单-例如详情页
 * url--->/pspList/detail
 * uri--->apps/pspDetail
 * 创建三级菜单-例如编辑页
 * url--->/pspList/edit
 * uri--->apps/pspEdit
 */

let service_path = "/tms-server-web"
let service_openpl_path = "/open_api"

let Host = "http://10.255.33.140"   //172.16.36.11 172.30.17.228
// let Host = "http://192.168.1.106"   //172.16.36.11 172.30.17.228
let ter_port = "8787" // 终端以外 8686
// let ter_port = "8055" // 终端以外 8686

// 临时替换 http://78.109.198.49:8686
// let Host = "http://78.109.198.49"
// let ter_port = "8686"


let port_app = "8686" // 应用端口 8082改8686
let port_openpl = "9090" // 开发平台端口 9090

let basePrefix = Host + ":" + ter_port
let basePrefix_sub = Host + ":"
let bannerFileUrl = ""
// let terminalPrefix = Host + ":" + port_t

if (!tms_devlope) {
  Host = (useSSL ? "https://" : "http://") + "tmsadmin.szzt.com.cn"  //tmsadmin.szzt.com.cn  boss.szzt.com.cn
  ter_port = useSSL ? "7443" : "8686" //7 https: "7443", http: 8686
  port_app = ter_port                 //8 应用端口,https: 8443, http: 8818
  port_openpl = useSSL ? "9090" : "9090" //8 应用端口,https: 8443, http: 8818
  basePrefix = Host + ":" + ter_port
  basePrefix_sub = Host + ":"
  bannerFileUrl =  Host + "/file-management" + service_path   // https://tmsadmin.szzt.com.cn/file-management/tms-server-web
}

export const focusEvent = function (fn) {
  if (fn) fn()
}
export const baseurl = basePrefix + service_path;
export const url = basePrefix;
// export const terUrl = terminalPrefix + '/zttms';




//true: 分布式部署， false: 单机部署
let distributedDeployment = false

// 各种资源路径
export const urlAssets = {
  prefix:  distributedDeployment ? 'http://172.16.7.49:22124/' : basePrefix + '/', // 文件/图片访问前缀
  apkUrl:  distributedDeployment ? 'http://172.16.7.49:22125/appFile/fileupload' : basePrefix + '/tms-server-web/appFile/fileupload.do', //apk文件上传地址
  fileUrl: distributedDeployment ? 'http://172.16.7.49:22125/file/fileupload' : basePrefix + '/tms-server-web/file/fileupload.do',   //文件上传地址
  xmlFileUrl: distributedDeployment ? 'http://172.16.7.49:22125/file/xmlUpload.do' : basePrefix + '/tms-server-web/file/xmlUpload.do',   //xml文件上传地址
  picUrl:  distributedDeployment ? 'http://172.16.7.49:22125/upload/upload' : basePrefix + '/tms-server-web/upload/upload.do',   //图片上传地址
  picUrls:  distributedDeployment ? 'http://172.16.7.49:22125/upload/upload' : 'https://tmsadmin.szzt.com.cn/file-management/tms-server-web/upload/upload.do',   //图片上传地址 2025/9/12 新应用图标上传地址
  webUrl:  distributedDeployment ? 'http://172.16.10.21:3314' : basePrefix,   //web接口 访问路径
  videoUrl:  distributedDeployment ? 'http://172.16.10.21:3314' : basePrefix,
}

// default build path /tms
export const projpath = ''
if (!localStorage.setlang) {
  localStorage.system_lang = defaultLang
}


export const wUrl = {
  host: basePrefix_sub,
  port: ter_port,	// 终端以外
  port_app: port_app,
  port_openpl: port_openpl,
  path: service_path,
  path_openpl: service_openpl_path,
  bannerFileUrl:bannerFileUrl
}



// WEBPACK FOOTER //
// ./src/api/url.js